import { Tile } from '../../../ui';
import type { CarrierEntityType, RegistrationAccountType, RegistrationDraft, RegistrationRole } from '../model';

export interface RegistrationTypeStepProps {
  role: RegistrationRole;
  draft: RegistrationDraft;
  updateDraft: (patch: Partial<RegistrationDraft>) => void;
  onSelectCustomerType: (type: 'person' | 'company') => void;
  onSelectCarrierType: (type: 'person' | 'sole_proprietor' | 'company') => void;
  figmaNode?: string;
}

export function RegistrationTypeStep({
  role,
  draft,
  updateDraft,
  onSelectCustomerType,
  onSelectCarrierType,
  figmaNode,
}: RegistrationTypeStepProps) {
  const isCustomer = role === 'customer';

  return (
    <div
      className={`standalone-auth__registration-form standalone-auth__registration-form--type${isCustomer ? '' : ' carrier-registration__form--type'}`}
      data-figma-node={figmaNode}
    >
      <div className="standalone-auth__copy">
        <h1>{isCustomer ? 'Кто вы?' : 'Тип перевозчика'}</h1>
        <p>{isCustomer ? 'Это определит, какие поля будут в профиле' : 'От этого зависит налоговая схема и поля профиля'}</p>
      </div>

      <div className={isCustomer ? 'request-wizard__account-tiles-wrapper' : 'carrier-registration__type-fields'}>
        <div className="request-wizard__role-banner request-wizard__role-banner--notice">
          📧 Аккаунта с email {draft.email || '—'} ещё нет — создадим новый
        </div>

        {isCustomer ? (
          <div className="request-wizard__account-tiles">
            <Tile
              active={draft.accountType === 'person'}
              title="Частное лицо"
              description="Я владелец животного и хочу его перевезти"
              onClick={() => {
                updateDraft({ accountType: 'person' });
                onSelectCustomerType('person');
              }}
            />
            <Tile
              active={draft.accountType === 'company'}
              title="Компания"
              description="Питомник, приют, зооклиника или другая организация"
              onClick={() => {
                updateDraft({ accountType: 'company' });
                onSelectCustomerType('company');
              }}
            />
          </div>
        ) : (
          <div className="carrier-registration__type-tiles" data-figma-node="2824:51503">
            <Tile
              active={draft.carrierEntityType === 'person'}
              title="Частное лицо"
              description="Самозанятый или физлицо без статуса. Чек формирует платформа."
              onClick={() => {
                updateDraft({ carrierEntityType: 'person', accountType: 'person' });
                onSelectCarrierType('person');
              }}
            />
            <Tile
              active={draft.carrierEntityType === 'sole_proprietor'}
              title="ИП"
              description="Индивидуальный предприниматель. Понадобится ИНН и реквизиты."
              onClick={() => {
                updateDraft({ carrierEntityType: 'sole_proprietor', accountType: 'company' });
                onSelectCarrierType('sole_proprietor');
              }}
            />
            <Tile
              active={draft.carrierEntityType === 'company'}
              title="Компания"
              description="Юридическое лицо. Понадобятся реквизиты организации."
              onClick={() => {
                updateDraft({ carrierEntityType: 'company', accountType: 'company' });
                onSelectCarrierType('company');
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
